module.exports = __webpack_public_path__ + "assets/img/logo.08167b3e.png";